export abstract class WorkspaceMigration {
    static migrations?: { [key: number]: (...args) => any };

    abstract migrate(...args): any;
}
